import React from 'react';
import { string, func, number } from 'prop-types';
import noop from 'lodash/noop';
import Modal from '@active/react-ui/Modal';

const WaiverModal = ({
  handleWaiverModalClose,
  passportBaseUrl,
  id,
  name,
  locale,
}) => {
  return (
    <Modal
      className="waiver-modal"
      title={name}
      shown={true}
      style={{ margin: 'auto' }}
      onClose={handleWaiverModalClose}
      size='lg'
      autoFocusClose={false}>
      <div className="modal-body">
        <iframe
          title={id}
          src={`${passportBaseUrl}/waiver?waiverId=${id}&waiverLocale=${locale}`}
          frameBorder="0"
          scrolling="auto"
          height="600"
          width="100%"/>
      </div>
      <div className="modal-footer"></div>
    </Modal>
  );
};

WaiverModal.propTypes = {
  locale: string,
  id: number.isRequired,
  name: string.isRequired,
  passportBaseUrl: string.isRequired,
  handleConfirmClose: func,
};

WaiverModal.defaultProps = {
  locale: 'en_US',
  handleConfirmClose: noop,
};

export default WaiverModal;
